// extracted by mini-css-extract-plugin
module.exports = {"frame":"FormImage_frame__3j3Xi","frameInner":"FormImage_frameInner__3MICB","content":"FormImage_content__3ef2r"};